import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { FaBurn } from "react-icons/fa";

import "../css/signup.css";

export default function Login() {

    const [cookies, setCookie, removeCookie] = useCookies(["userPuuId"]);

    const [ username, setUsername ] = useState("");
    const [ password, setPassword ] = useState("");
    const [ socialname, setSocialName ] = useState("");
    const [ passwordConfirm, setPassConfirm ] = useState("");

    function doLogin(event) {
        event.preventDefault();

        function hasWhiteSpace(s) {
            return /\s/g.test(s);
        };

        if(hasWhiteSpace(username) == true) {
            document.getElementById("errorDiv").hidden = false;
            document.getElementById("errorDiv").innerText = `Seu nome de usuário não pode conter espaços`;
            return false;
        }

        if(password != passwordConfirm) {
            document.getElementById("errorDiv").hidden = false;
            document.getElementById("errorDiv").innerText = `Suas senhas não conferem`;
            return false;
        }

        axios.post("https://cloudify-backend.herokuapp.com/users/create", {
            "username":username,
            "socialname":socialname,
            "password":password
        })
        .then(resp => {
            console.log(resp.data);
            if(resp.data.sucesso == true) {
                setCookie("userPuuId", resp.data.userId);
                window.location.href = "/";
            }
        });
    }

    return (
        <div className="centered">
            <div className="wrapper fadeInDown">
                <div id="formContent">
                    <Link to="/login"> <h2 className="inactive underlineHover"> Sign In </h2> </Link>
                    <h2 className="active" id="signupButton" >Sign Up </h2>

                    <div className="fadeIn first">
                        <img src="https://i.ibb.co/px3GVFk/icon-rounded.png" id="icon" alt="User Icon" />
                    </div>

                    <form onSubmit={doLogin} >
                        <input type="text" id="login" className="fadeIn second" name="login" placeholder="Nome de usuário" onChange={(key) => { setUsername(key.target.value) }} value={username} />
                        <input type="text" id="login" className="fadeIn second" name="login" placeholder="Nome de exibição" onChange={(key) => { setSocialName(key.target.value) }} value={socialname} />
                        <input type="password" id="password" className="fadeIn third" name="login" placeholder="Senha" onChange={(key) => { setPassword(key.target.value) }} value={password} />
                        <input type="password" id="password" className="fadeIn third" name="login" placeholder="Confirme sua senha" onChange={(key) => { setPassConfirm(key.target.value) }} value={passwordConfirm} />
                        
                        <div className="centered">
                            <div id="errorDiv" hidden>
                                <div className="centered">
                                    <FaBurn />
                                </div>

                                <div className="centered">
                                    <h3 id="errorDivText" />
                                </div>
                            </div>
                        </div>

                        <input type="submit" className="fadeIn fourth" value="Criar" id="loginButton" onSubmit={doLogin} />
                    </form>
                </div>
            </div>
        </div>
    )
}